import {
  useCompositeInput
} from "../__chunks/43VDSLJP.js";
import {
  useToolbarItem
} from "../__chunks/P4CYWFUE.js";
import "../__chunks/FVD2NJZN.js";
import "../__chunks/P4RGQGTG.js";
import "../__chunks/VFNGSUSF.js";
import "../__chunks/T3DJZG63.js";
import "../__chunks/OXPV2NBK.js";
import "../__chunks/WJ37OVG2.js";
import "../__chunks/MYID4V27.js";
import "../__chunks/BMLNRUFQ.js";
import {
  createElement,
  createHook,
  createMemoComponent
} from "../__chunks/NQJBHION.js";
import "../__chunks/P63NRZ4A.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/toolbar/toolbar-input.ts
var useToolbarInput = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = useCompositeInput(__spreadValues({ store }, props));
    props = useToolbarItem(__spreadValues({ store }, props));
    return props;
  }
);
var ToolbarInput = createMemoComponent(
  (props) => {
    const htmlProps = useToolbarInput(props);
    return createElement("input", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  ToolbarInput.displayName = "ToolbarInput";
}
export {
  ToolbarInput,
  useToolbarInput
};
